import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { BubbleMenu } from '@tiptap/extension-bubble-menu';
import Image from '@tiptap/extension-image';
import Underline from '@tiptap/extension-underline';
import TextStyle from '@tiptap/extension-text-style';
import styled from 'styled-components';
import { Color } from '@tiptap/extension-color';
import { forwardRef, useEffect } from 'react';
import { ImageResize } from './extensions/image-resize';
import { TextAlign } from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder';
import { styleVariables } from '../../style';
import MenuEditorBubleComponent from './component/menu-editor-buble.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLayout = styled.div.withConfig({
  displayName: "editor-bublecomponent__StyledLayout",
  componentId: "sc-17fv9jj-0"
})([".tiptap{margin-bottom:", ";table{border-collapse:collapse;margin:0;overflow:hidden;table-layout:fixed;width:100%;td,th{position:relative;p{position:inherit;z-index:2;}}.selectedCell::after{background-color:#cbe1f79e;content:'';left:0;right:0;top:0;bottom:0;pointer-events:none;position:absolute;z-index:1;}.column-resize-handle{background-color:", ";bottom:-2px;pointer-events:none;position:absolute;right:-2px;top:0;width:4px;}}.tableWrapper{margin:1.5rem 0;overflow-x:auto;}&.resize-cursor{cursor:ew-resize;cursor:col-resize;}}.ProseMirror{max-height:14vh;min-height:10vh;overflow-y:auto;padding:", ";border:", " solid ", ";border-radius:", ";outline:none !important;img{max-width:100%;}}p.is-editor-empty:first-child::before{color:", ";font-style:italic;content:attr(data-placeholder);float:left;height:0;pointer-events:none;}"], styleVariables.margin.large, styleVariables.colors.gray6, styleVariables.padding.large, styleVariables.borderWidth.small, styleVariables.colors.gray6, styleVariables.borderRadius.medium, styleVariables.colors.gray9);
var StyledEditorContent = styled(EditorContent).withConfig({
  displayName: "editor-bublecomponent__StyledEditorContent",
  componentId: "sc-17fv9jj-1"
})(["max-height:", ";overflow-y:", ";& > *{pointer-events:", ";}"], function (props) {
  return props.scrollable ? '70vh' : 'none';
}, function (props) {
  return props.scrollable ? 'auto' : 'visible';
}, function (props) {
  return props.disabled && 'none';
});
export var EditorBubble = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      content = _ref.content,
      editorLabels = _ref.editorLabels,
      disabled = _ref.disabled,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      _onFocus = _ref.onFocus;
  var editor = useEditor({
    extensions: [StarterKit, ImageResize, TextAlign.configure({
      types: ['heading', 'paragraph']
    }), Image.configure({
      inline: true
    }), Underline, TextStyle, Color, BubbleMenu, Placeholder.configure({
      placeholder: placeholder || 'Write something...'
    })],
    content: content === placeholder ? '' : content,
    onUpdate: function onUpdate() {
      onChange === null || onChange === void 0 ? void 0 : onChange(editor.getHTML());
    },
    onFocus: function onFocus() {
      _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus();
    }
  });
  useEffect(function () {
    return function () {
      if (editor) editor.destroy();
    };
  }, [editor]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledLayout, {
      children: /*#__PURE__*/_jsx(StyledEditorContent, {
        editor: editor,
        disabled: disabled,
        scrollable: scrollable
      })
    }), /*#__PURE__*/_jsx(MenuEditorBubleComponent, {
      editor: editor,
      labels: editorLabels
    })]
  });
});